export const OPEN_WHATSAPP_PANEL_EVENT = 'swarna:open-whatsapp-panel';

export interface OpenWhatsAppPanelDetail {
  phone10: string;
  name?: string | null;
  leadId?: string | null;
  brokerId?: string | null;
}

/** Ask the globally mounted WhatsApp panel to open one conversation. */
export function openWhatsAppPanel(detail: OpenWhatsAppPanelDetail): boolean {
  const phone10 = String(detail.phone10 || '').replace(/\D/g, '').slice(-10);
  if (phone10.length !== 10) return false;

  window.dispatchEvent(new CustomEvent<OpenWhatsAppPanelDetail>(OPEN_WHATSAPP_PANEL_EVENT, {
    detail: { ...detail, phone10 },
  }));
  return true;
}
